export const COPY = {
  line1:
    'Your tradesperson has notified Ideal4Finance that they have finished your job.',
  line2:
    'You now need to sign off on the work or let us know if there is a problem.',
};
